<div *ngIf="!choose">
<button (click)="setupDialer()">Setup Dialer integration</button>
<button (click)="setupLeads()">Setup Leads integration</button>
</div>

<app-upsales-dialer *ngIf="isDialerChoosen"></app-upsales-dialer>

<app-upsales-leads *ngIf="isLeadsChoosen"></app-upsales-leads>